import api from '@/api/price-survey';

export default {
  state: {
    categories: [],
    selectedCategory: null,
    selectedSurvey: null,
    surveySpecification: null,
    surveyStore: null,
    specificationHistory: null,
  },

  getters: {
    getPriceSurveyCategories: state => state.categories,
    getSelectedPriceSurveyCategory: state => state.selectedCategory,
    getSelectedPriceSurvey: state => state.selectedSurvey,
    getPriceSurveySpecification: state => state.surveySpecification,
    getPriceSurveyStore: state => state.surveyStore,
    getPriceSurveySpecificationHistory: state => state.specificationHistory,
  },

  actions: {
    async fetchPriceSurveyCategories({ commit }) {
      try {
        const response = await api.getPriceSurveyCategoriesList();

        commit('SET_CATEGORIES', response.data.data);
      } catch (error) {
        commit('SET_CATEGORIES', []);
      }
    },

    async selectPriceSurveyCategory({ commit }, payload) {
      const params = {
        page: 1,
        per_page: 10,
      };

      try {
        const response = await api.getPriceSurveyListByCategory(payload, params);

        commit('SET_CATEGORY', response.data);
      } catch (error) {
        commit('SET_CATEGORY', []);
      }
    },

    async searchSurveysInCategory({ commit }, payload) {
      try {
        const response = await api.getPriceSurveyListByCategory(payload.slug, payload.params);

        commit('SET_CATEGORY', response.data);
      } catch (error) {
        commit('SET_CATEGORY', []);
      }
    },

    async selectPriceSurvey({ commit }, payload) {
      try {
        const response = await api.getPriceSurveyDetails(payload);

        commit('SET_SURVEY', response.data.data);
      } catch (error) {
        commit('SET_SURVEY', null);
      }
    },

    async fetchPriceSurveySpecification({ commit }, payload) {
      try {
        const response = await api.getPriceSurveySpecification(payload.slug, payload.id);

        commit('SET_SPECIFICATION', response.data.data);
      } catch (error) {
        commit('SET_SPECIFICATION', null);
      }
    },

    async fetchPriceSurveyStore({ commit }, payload) {
      try {
        const response = await api.getPriceSurveyStore(payload.slug, payload.id);

        commit('SET_STORE', response.data.data);
      } catch (error) {
        commit('SET_STORE', null);
      }
    },

    async fetchPriceSurveySpecificationHistory({ commit }, payload) {
      try {
        const response = await api.getPriceSurveyItemHistory(payload.slug, payload.item, payload.store);

        commit('SET_SPECIFICATION_HISTORY', response.data.data);
      } catch (error) {
        commit('SET_SPECIFICATION_HISTORY', null);
      }
    }
  },

  mutations: {
    SET_CATEGORIES(state, payload) {
      state.categories = payload;
    },
    SET_CATEGORY(state, payload) {
      state.selectedCategory = payload;
    },
    SET_SURVEY(state, payload) {
      state.selectedSurvey = payload;
    },
    SET_SPECIFICATION(state, payload) {
      state.surveySpecification = payload;
    },
    SET_STORE(state, payload) {
      state.surveyStore = payload;
    },
    SET_SPECIFICATION_HISTORY(state, payload) {
      state.specificationHistory = payload;
    }
  }
};
